import { render, staticRenderFns } from "./resales.page.vue?vue&type=template&id=19237581&scoped=true&"
import script from "./resales.page.vue?vue&type=script&lang=js&"
export * from "./resales.page.vue?vue&type=script&lang=js&"
import style0 from "./resales.page.vue?vue&type=style&index=0&id=19237581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19237581",
  null
  
)

export default component.exports